import { render, staticRenderFns } from "./reservationNum.vue?vue&type=template&id=b833af90&scoped=true"
import script from "./reservationNum.vue?vue&type=script&lang=js"
export * from "./reservationNum.vue?vue&type=script&lang=js"
import style0 from "./reservationNum.vue?vue&type=style&index=0&id=b833af90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b833af90",
  null
  
)

export default component.exports